// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module__banner___2voLl","container":"Banner-module__container___1z3h3","list":"Banner-module__list___3CJ6E","bullet":"Banner-module__bullet___1dLX2"};